import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "../redux/reducers/Models";
import { getIsValidString } from "@/utils/functions";
import { clearUser } from "../redux/ducks/user";
import { useNavigate } from "react-router-dom";
import { useLayoutEffect } from "react";

const useRedirect = (page: string, blockRedirect?: boolean) => {
  const navigate = useNavigate();
  const user = useSelector(
    (
      state: ReducersTypes & {
        userReducer: {
          cart: {
            name: string;
            checked: boolean;
          }[];
          debts: {
            name: string;
            checked: boolean;
          }[];
        };
      },
    ) => state.userReducer,
  );
  const dispatch = useDispatch();

  const pageConditions: { [key: string]: (string | undefined)[] } = {
    "ticket/user": [],
    "ticket/pin": [user?.document as string],
    ticket: [
      user?.document as string,
      user?.pin as string,
      user?.accessToken as string,
    ],
    home: [user?.plate as string, user?.accessToken as string],
    details: [
      user?.plate as string,
      user?.accessToken as string,
      ...(user?.debts?.length > 0 ? [] : ["invalid_debts"]),
    ],
    checkout: [
      user?.plate as string,
      user?.requestId as string,
      user?.accessToken as string,
      ...(user?.cart?.length > 0 ? [] : ["invalid_cart"]),
      ...(user?.debts?.length > 0 ? [] : ["invalid_debts"]),
    ],
    "checkout/user": [
      user?.plate as string,
      user?.requestId as string,
      user?.accessToken as string,
      ...(user?.cart?.length > 0 ? [] : ["invalid_cart"]),
      ...(user?.debts?.length > 0 ? [] : ["invalid_debts"]),
    ],
    "checkout/card": [
      user?.plate as string,
      user?.requestId as string,
      user?.accessToken as string,
      ...(user?.cart?.length > 0 ? [] : ["invalid_cart"]),
      ...(user?.debts?.length > 0 ? [] : ["invalid_debts"]),
    ],
    "checkout/pix": [
      user?.plate as string,
      user?.requestId as string,
      user?.accessToken as string,
      ...(user?.cart?.length > 0 ? [] : ["invalid_cart"]),
      ...(user?.debts?.length > 0 ? [] : ["invalid_debts"]),
    ],
  };

  const redirect = () => {
    navigate("/");
    dispatch(clearUser());
  };

  const conditions = pageConditions[page] || [];

  useLayoutEffect(() => {
    if (
      conditions.some((condition) => !getIsValidString(condition)) &&
      !blockRedirect
    ) {
      redirect();
    }
  });

  return {
    isValid: !conditions.some((condition) => !getIsValidString(condition)),
    redirect,
  };
};

export default useRedirect;
